<template>
<div class="chapter">
<div class="inner_page">
<p class="cip-break" id="copy"><a id="pIV"></a>Published with assistance from the income of the Frederick John Kingsbury Memorial Fund.</p>
<p class="cip">Published with assistance from the Annie Burr Lewis Fund.</p>
<p class="cip">Published with assistance from the foundation established in memory of Calvin Chapin of the Class of 1788, Yale College.</p>
<p class="linespace"></p>
<p class="cip">Copyright © 2019 by Sarah M. S. Pearsall.</p>
<p class="cip">All rights reserved.</p>
<p class="cip">This book may not be reproduced, in whole or in part, including illustrations, in any form (beyond that copying permitted by Sections 107 and 108 of the U.S. Copyright Law and except by reviewers for the public press), without written permission from the publishers.</p>
<p class="linespace"></p>
<p class="cip">Yale University Press books may be purchased in quantity for educational, business, or promotional use. For information, please e-mail <a href="mailto:sales.press@yale.edu">sales.press@yale.edu</a> (U.S. office) or <a href="mailto:sales@yaleup.co.uk">sales@yaleup.co.uk</a> (U.K. office).</p>
<p class="linespace"></p>
<p class="cip">Set in Fournier MT type by IDS Infotech Ltd.</p>
<p class="cip">Printed in the United States of America.</p>
<p class="linespace"></p>
<p class="cip">Library of Congress Control Number: 2018962621</p>
<p class="cip">ISBN 978-0-300-22684-3 (hardcover : alk. paper)</p>
<p class="linespace"></p>
<p class="cip">A catalogue record for this book is available from the British Library.</p>
<p class="linespace"></p>
<p class="cip">This paper meets the requirements of ANSI/NISO Z39.48-1992 (Permanence of Paper).</p>
<p class="linespace"></p>
<p class="cip">10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?36d92d09